import React from 'react';
import { ApButtonLink } from '@alixpartners/ui-components';

import {
  ContentBlock,
  CostLabel,
  CostValue,
  Description,
  RightSection,
  RightSectionColumn,
  SectionWrapper,
  Title,
} from '../../EnvironmentSetup/EnvironmentSetup.styles';
import CodeSnippet from '../../../../components/CodeSnippet';

interface IProps {
  databricksWorkspaceId: string;
  databricksWorkspaceName: string;
  databricksWorkspaceUrl: string;
}

export const DataBricksSection = ({
  databricksWorkspaceId,
  databricksWorkspaceName,
  databricksWorkspaceUrl,
}: IProps) => {
  return (
    <SectionWrapper animationIndex={2}>
      <Title>Databricks</Title>
      <ContentBlock>
        <Description>Azure Databricks Workspace</Description>
        <RightSection>
          <RightSectionColumn>
            <CostLabel>Workspace Name</CostLabel>
            <CodeSnippet>{databricksWorkspaceName}</CodeSnippet>
          </RightSectionColumn>
          <RightSectionColumn>
            <CostLabel>Workspace ID</CostLabel>
            <CodeSnippet>{databricksWorkspaceId}</CodeSnippet>
          </RightSectionColumn>
          <RightSectionColumn />
        </RightSection>
      </ContentBlock>
      <ContentBlock>
        <Description />
        <RightSection>
          <CostValue>
            <ApButtonLink
              target="_blank"
              href={databricksWorkspaceUrl}
              rel="noopener noreferrer"
            >
              Databricks workspace link
            </ApButtonLink>
          </CostValue>
        </RightSection>
      </ContentBlock>
    </SectionWrapper>
  );
};
